<div class="flex-column gap p-2">
    <app-select-input
        [form]="form"
        id="headerId"
        label="service.patterns.header"
        [staticOptions]="store.headers()"
        [autoDisplayFirst]="true"
        valueKey="id"
    ></app-select-input>
    <app-select-input
        [form]="form"
        id="footerId"
        label="service.patterns.footer"
        [staticOptions]="store.footers()"
        [autoDisplayFirst]="true"
        valueKey="id"
    ></app-select-input>

    @if (form.controls.fontSize.enabled) {
        <app-select-input
            [form]="form"
            id="fontSize"
            label="common.fontSize"
            [staticOptions]="baseExportFontSizeEnumOptions"
            [autoDisplayFirst]="true"
        ></app-select-input>
    }

    <ng-content></ng-content>

    <app-check-input
        [form]="form"
        id="archive"
        label="common.archive"
    ></app-check-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        primaryButtonLabel="common.print"
        primaryButtonType="print"
        [primaryButtonDisability]="form.invalid"
        [primaryButtonLoading]="processing"
        (primaryClickEvent)="print()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
